import type { HTMLAttributes, ReactNode } from "react";

type PlatformCardProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
  padding?: "none" | "sm" | "md" | "lg";
};

const paddingClasses: Record<
  NonNullable<PlatformCardProps["padding"]>,
  string
> = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

export function PlatformCard({
  children,
  className = "",
  padding = "md",
  ...props
}: PlatformCardProps) {
  return (
    <section
      {...props}
      className={[
        "rounded-2xl border border-slate-200 bg-white shadow-sm",
        paddingClasses[padding],
        className,
      ].join(" ")}
    >
      {children}
    </section>
  );
}